import { GameObj } from "../GameObj";
import { randomPositionInRadius } from "../geometry";
import { globals } from "../types";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class Pentagram extends UnitType {
    readonly id = "pentagram";
    readonly displayName = "Pentagram";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.overworld; }
    canEnter(ctx: PlaceContext) { return this.inTile(ctx, ["land"], ctx.game.overworld); }
    description() { return "Teleports units from the Netherworld."; }
    cost() { return { blood: 1000, souls: 10, runes: 20 }; }
    img(ctx: UnitContext) { return "pentagram_" + ctx.faction; }
    maxCooldown() { return 0; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "pentagram"); }
    step(ctx: ObjContext) {
        const objInNetherworld = ctx.game.netherworld.get(ctx.x, ctx.y);
        if (objInNetherworld) {
            const pos = randomPositionInRadius(ctx.x, ctx.y, 1);
            const moved = ctx.game.tryMove(objInNetherworld, pos.x, pos.y, ctx.game.overworld, true);
            if (moved) {
                globals.audio.playSound("warp");
                ctx.game.netherworld.removeById(objInNetherworld.id);
            }
        }
    }
}
